import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "meeting-note-container meeting-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flow-title" }, "Create Meeting Type"),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Description")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "message-container" }, "Add any details about this type of meeting. This will be seen before someone schedules a meeting with you.", -1 /* HOISTED */)
const _hoisted_5 = { class: "note-container flex-center" }
const _hoisted_6 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode($setup["TextField"], {
          class: "note invite-note",
          label: "Description",
          modelValue: $setup.message,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.message) = $event))
        }, null, 8 /* PROPS */, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "borderless previous",
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.emit('previous')))
      }, "Back"),
      _createElementVNode("button", {
        class: "borderless confirm-details",
        onClick: $setup.setNote
      }, _toDisplayString($setup.message ? 'Next' : 'Skip'), 1 /* TEXT */)
    ])
  ]))
}